.loadMore {
  display: block;
  font-family: var(--ogm-font-family-1);
  font-size: 14px;
  text-align: center;
  padding: 10px;
  color: #fff;
  text-transform: uppercase;
  margin: 0 auto;
  width: 100%;
  border: solid 2px var(--ogm-mavericks);
  box-sizing: border-box;
  cursor: pointer;
}

@keyframes tickAnimation {
  0% {
    opacity: 0.9;
  }
  20% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  70% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
  }
}
.multiBetslipWrapper {
  height: 100%;
  margin-bottom: 65px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.multiBetslipWrapper::-webkit-scrollbar {
  display: none;
}
.multiBetslipWrapper .selectedBookie {
  display: flex;
  background: var(--ogm-white);
  z-index: var(--cxy-z-index-internal-high);
  position: fixed;
  top: 54px;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 2px 4px 0px;
  border-bottom: none;
}
.multiBetslipWrapper .selectedBookie .bookie {
  flex: 1;
  margin: 8px;
  border-radius: 8px;
  padding: 0 8px;
  background-color: rgba(41, 42, 46, 0.15);
  color: var(--ogm-black);
}
.multiBetslipWrapper .scrollWrapper {
  margin-top: 100px;
  height: auto;
}
.betList {
  list-style: none;
  margin: 0;
  padding: 0;
}
.multiBetslipWrapper .selectedBookie {
  width: 100%;
}
.multiBetslipWrapper .otherBookies {
  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 15px 15px 0 15px;
}

[data-fpsm-theme='gazzetta'] {
  .multiBetslipWrapper .selectedBookie {
    background: var(--cxy-color-container-extra);
  }

  .multiBetslipWrapper .selectedBookie .bookie {
    background-color: var(--cxy-color-container-default);
    color: var(--ogm-black);
  }
}
